import PropTypes from 'prop-types'
import { ParagraphMedium } from 'baseui/typography'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import { PulseSubhead } from '@/shared/components/PulseScope/styled-components'

const Subtitle = ({ hidden, text }) => {
  const isPulse = usePulseScope()

  if (hidden) {
    return null
  }
  if (isPulse) return <PulseSubhead>{text}</PulseSubhead>

  return <ParagraphMedium>{text}</ParagraphMedium>
}

Subtitle.propTypes = {
  hidden: PropTypes.bool,
  text: PropTypes.string,
}

export default Subtitle
